import {
  faArrowRotateLeft,
  faBoxOpen,
  faCheck,
  faClose,
  faTruckClock,
} from '@fortawesome/pro-solid-svg-icons'

import type { ShipmentTrackingCardType } from 'Components/ShipmentTrackingCard/ShipmentTrackingCard.types'

import {
  TrackingStatusEnum,
  type TrackingStatusModel,
} from 'Types/trackingStatus/trackingStatus.types'

export const TRACKING_STATUS_MODEL: Record<
  ShipmentTrackingCardType,
  TrackingStatusModel
> = {
  order: {
    [TrackingStatusEnum.created]: {
      icon: faBoxOpen,
      translationId: {
        delivered: 'Delivery_status_Created',
        transit: 'Delivery_status_Created',
      },
    },
    [TrackingStatusEnum.transit]: {
      icon: faTruckClock,
      translationId: {
        delivered: 'Delivery_status_Transit',
        transit: 'Delivery_status_Transit',
      },
    },
    [TrackingStatusEnum.delivered]: {
      icon: faCheck,
      translationId: {
        delivered: 'Delivery_status_Delivered',
        transit: 'Delivery_status_Delivery',
      },
    },
    [TrackingStatusEnum.failure]: {
      icon: faClose,
      translationId: {
        delivered: 'Delivery_status_Failure',
        transit: 'Delivery_status_Failure',
      },
    },
    [TrackingStatusEnum.returned_to_sender]: {
      icon: faArrowRotateLeft,
      translationId: {
        delivered: 'Delivery_status_ReturnToSender',
        transit: 'Delivery_status_ReturnToSender',
      },
    },
  },
  return: {
    [TrackingStatusEnum.created]: {
      icon: faBoxOpen,
      translationId: {
        delivered: 'Delivery_status_return_Created',
        transit: 'Delivery_status_return_Created',
      },
    },
    [TrackingStatusEnum.transit]: {
      icon: faTruckClock,
      translationId: {
        delivered: 'Delivery_status_return_Transit',
        transit: 'Delivery_status_return_Transit',
      },
    },
    [TrackingStatusEnum.delivered]: {
      icon: faCheck,
      translationId: {
        delivered: 'Delivery_status_return_Delivered',
        transit: 'Delivery_status_Delivery',
      },
    },
    [TrackingStatusEnum.failure]: {
      icon: faClose,
      translationId: {
        delivered: 'Delivery_status_return_Failure',
        transit: 'Delivery_status_return_Failure',
      },
    },
    [TrackingStatusEnum.returned_to_sender]: {
      icon: faArrowRotateLeft,
      translationId: {
        delivered: 'Delivery_status_return_ReturnToSender',
        transit: 'Delivery_status_return_ReturnToSender',
      },
    },
  },
}
